module.exports = __webpack_public_path__ + "img/red-icon-en(1).3859b706.png";